import React from 'react';
import Card from '../ds/Card';
import { Isotype } from '../ds/Logo';
import Icon from '../lib/Icon';

/** Stand-in page body for Console sections that land in later sub-projects. */
export default function Placeholder({ icon = 'layers', title, blurb }) {
  return (
    <div style={{ padding: '30px 36px 56px', maxWidth: 1240, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
      <div className="cc-eyebrow" style={{ marginBottom: 6 }}>Coachability Console</div>
      <h1 style={{ margin: 0, fontSize: 'var(--text-h2)', letterSpacing: 'var(--track-display)' }}>{title}</h1>
      <Card elevation="sm" style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: 16, padding: '32px' }}>
        <span style={{
          display: 'inline-flex', width: 48, height: 48, alignItems: 'center', justifyContent: 'center',
          borderRadius: 'var(--radius-md)', background: 'var(--science-100)', color: 'var(--science-700)', flex: 'none',
        }}>
          <Icon name={icon} size={22} />
        </span>
        <div>
          <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-h4)', letterSpacing: 'var(--track-tight)' }}>
            This screen arrives later in the redesign
          </div>
          <div className="cc-prose" style={{ color: 'var(--ink-soft)', fontSize: 'var(--text-base)', maxWidth: '62ch' }}>
            {blurb || 'The Console is being rebuilt screen by screen on the redesign branch. This section keeps its place in the navigation until its sub-project lands.'}
          </div>
        </div>
        <Isotype size={20} style={{ color: 'var(--science-400)', marginLeft: 'auto' }} />
      </Card>
    </div>
  );
}
